import { render, staticRenderFns } from "./ListDeviceAccessories.vue?vue&type=template&id=4a533c3c&"
import script from "./ListDeviceAccessories.vue?vue&type=script&lang=js&"
export * from "./ListDeviceAccessories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/DeviceAccessoryTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Flist-device-accessories%2FListDeviceAccessories.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports